module.exports = __webpack_public_path__ + "static/media/Family-business-Cases.8f9aa62e.jpg";